const CLUB_WORKSPACE_ROLES = new Set(['club', 'club_admin', 'team_admin', 'staff'])
const COACH_WORKSPACE_ROLES = new Set(['coach', 'trainer'])
const ATHLETE_WORKSPACE_ROLES = new Set(['player', 'athlete'])
const SPONSOR_WORKSPACE_ROLES = new Set(['sponsor', 'partner'])

function normalizeRole(role) {
  return String(role ?? '')
    .trim()
    .toLowerCase()
}

function normalizeRoles(roles = []) {
  return new Set(Array.isArray(roles) ? roles.map(normalizeRole).filter(Boolean) : [])
}

function pathFromRole(role) {
  const normalized = normalizeRole(role)
  if (ATHLETE_WORKSPACE_ROLES.has(normalized)) return '/player'
  if (COACH_WORKSPACE_ROLES.has(normalized)) return '/coach'
  if (CLUB_WORKSPACE_ROLES.has(normalized)) return '/club'
  if (SPONSOR_WORKSPACE_ROLES.has(normalized)) return '/sponsor'
  if (normalized === 'admin') return '/admin/campaign-owners'
  return null
}

export function workspaceRoleFromOnboardingRoles(roles = []) {
  const normalized = normalizeRoles(roles)

  if ([...CLUB_WORKSPACE_ROLES].some((role) => normalized.has(role))) return 'club'
  if ([...COACH_WORKSPACE_ROLES].some((role) => normalized.has(role))) return 'coach'
  if ([...SPONSOR_WORKSPACE_ROLES].some((role) => normalized.has(role))) return 'sponsor'
  return 'player'
}

export function workspacePathFromOnboardingRoles(roles = []) {
  return `/${workspaceRoleFromOnboardingRoles(roles)}`
}

export function workspacePathFromUser(user) {
  if (!user) return '/login'

  const activeRolePath = pathFromRole(user.role)
  if (activeRolePath) return activeRolePath

  const profileRoles = normalizeRoles(user.profile?.roles ?? [])
  if ([...CLUB_WORKSPACE_ROLES].some((role) => profileRoles.has(role))) return '/club'
  if ([...COACH_WORKSPACE_ROLES].some((role) => profileRoles.has(role))) return '/coach'
  if ([...SPONSOR_WORKSPACE_ROLES].some((role) => profileRoles.has(role))) return '/sponsor'
  if ([...ATHLETE_WORKSPACE_ROLES].some((role) => profileRoles.has(role))) return '/player'

  return '/player'
}
